import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class ReasonOfExtensionInsertService {

  private apiUrl = globalConst.baseAPI;
  constructor(private http: Http) { }

  insertCompanyType(token, reasonOfExtension: any) {
  	return this.http
  	.post(this.apiUrl + "motivoprorrogacao/v1/inserirmotivoprorrogacao", reasonOfExtension, JSON.parse(localStorage.getItem('yara.connectionHeader')))
  	.map((res: Response) => res.json())
  	.catch(e => {
  		if (e.status === 401) {
  			return Observable.throw('Unauthorized');
  		}
  	});
  }

}



// WEBPACK FOOTER //
// ./src/app/reason-of-extension/service/reason-of-extension-insert/reason-of-extension-insert.service.ts